// extracted by mini-css-extract-plugin
module.exports = {"root":"AddEntry_root__Y5e1-","editIcon":"AddEntry_editIcon__2uv2a"};